import { APIClientInterface } from "../context/InternalContext";

/**
 * Module-level API client reference.
 * This is set by the InternalProvider when it receives the API client from the web app.
 * Services import this to make API calls with the web app's configured client.
 */
let apiClientInstance: APIClientInterface | null = null;

export const setApiClient = (client: APIClientInterface) => {
  apiClientInstance = client;
};

export const getApiClient = (): APIClientInterface => {
  if (!apiClientInstance) {
    throw new Error(
      "API client not initialized. Make sure InternalProvider is rendered with an apiClient prop."
    );
  }
  return apiClientInstance;
};

/**
 * API client instance for use in services.
 * This references the web app's API client with all its configuration.
 */
export const api = new Proxy({} as APIClientInterface, {
  get(_target, prop) {
    const client = getApiClient();
    const value = client[prop as keyof APIClientInterface];
    if (typeof value === "function") {
      return value.bind(client);
    }
    return value;
  },
});
